/// <reference path="../app.ts" />
namespace Cfnc {
    export interface IOrganizationDataService {
        getOrganizations: () => ng.IPromise<any>;
        getOrganizationById: (id: string) => ng.IPromise<any>;
    }

    export class OrganizationDataService implements IOrganizationDataService {
        static serviceId: string = "organizationDataService";

        constructor(private Restangular: Restangular.IService, private common: ICommonFactory, private $http: ng.IHttpService) {
        }

        getOrganizations() {
            var deferred = this.common.$q.defer();
            this.Restangular.all("organizations").getList()
                .then((result) => {
                    deferred.resolve(result);
                },
                (reason) => {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        getOrganizationById(id: string) {
            var deferred = this.common.$q.defer();
            this.Restangular.one(id).get()
                .then((results) => {
                    deferred.resolve(results);
                },
                (reason) => {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }

    angular.module("app").factory(OrganizationDataService.serviceId, ["Restangular", "common", "$http", (Restangular: Restangular.IService, common: ICommonFactory, $http: ng.IHttpService) =>
        new OrganizationDataService(Restangular, common, $http)
    ]);
}